"use client";
import { jsx as h } from "react/jsx-runtime";
import { memo as c } from "react";
import v from "../components/Icon/SvgIcon.js";
const e = (o) => /* @__PURE__ */ h(
  v,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...o,
    children: /* @__PURE__ */ h(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M20.75 9.846v.741c0 .758-.617 1.375-1.375 1.375h-4.75v-.157c0-.62-.505-1.125-1.125-1.125h-3c-.62 0-1.125.505-1.125 1.125v.157h-4.75a1.377 1.377 0 0 1-1.375-1.375V8.846c0-.758.617-1.375 1.375-1.375h14.75c.758 0 1.375.617 1.375 1.375zm-10.125 3.552V11.93h2.75v1.468zm10.125 4.189c0 .758-.617 1.375-1.375 1.375H4.625a1.377 1.377 0 0 1-1.375-1.375v-4.774c.401.249.869.399 1.375.399h4.75v.311c0 .62.505 1.125 1.125 1.125h3c.62 0 1.125-.505 1.125-1.125v-.311h4.75c.506 0 .974-.15 1.375-.399zM9.625 5.625A.38.38 0 0 1 10 5.25h4c.207 0 .375.168.375.375v.596h-4.75zm9.75.596h-3.75v-.596C15.625 4.729 14.896 4 14 4h-4c-.896 0-1.625.729-1.625 1.625v.596h-3.75A2.63 2.63 0 0 0 2 8.846v8.741a2.63 2.63 0 0 0 2.625 2.625h14.75A2.63 2.63 0 0 0 22 17.587V8.846a2.63 2.63 0 0 0-2.625-2.625",
        clipRule: "evenodd"
      }
    )
  }
), r = c(e);
export {
  r as Jobs,
  r as default
};
